import { allVideos } from './all-videos';

export const views = {
  allVideos,
};
